import { useAuth } from "@/context/AuthContext";
import { PageBanner } from "@/components/ui/PageBanner";
import { IMG } from "@/lib/assets";
import { WeekTimetable, TimetableEditor } from "@/components/perform/Timetable";

export default function TimetablePage() {
  const { user } = useAuth();
  const staff = ["owner", "coach"].includes(user?.club_role) && user?.club_active;
  const inClub = user?.club_id && user?.club_active;
  return (
    <div className="p-4 md:p-8 space-y-6">
      <PageBanner image={IMG.conditioning} overline={user?.club_name || "your club"} title="Timetable"
        subtitle={staff ? "Your gym's week. Set regular classes once and they appear on every athlete's calendar, ready to book." : "Book your classes for the week. After class, log the workout in one tap and it goes to your own training log."} />
      {inClub ? <WeekTimetable /> : <p className="surface rounded-2xl p-6 text-sm text-[#8A91A6]">Join your club with its code (Memberships page) to see and book its classes.</p>}
      {staff && <TimetableEditor />}
    </div>
  );
}
